<script>
    // component for filtering by domains 13131
    export default {
        template: '#domain-filter',
        props: ['current_route'],
        data: function () {
            return {
                domains: []
            };
        },
        mounted : function () {
            let saved_properties = JSON.parse(localStorage.getItem(this.current_route));

            if (saved_properties !== null && saved_properties.domainFilters) {
                    this.domains = saved_properties.domainFilters;
            }
        },
        watch: {
            // save checkboxes when we change domains filter
            'domains' : function(val) {
                localStorage.setItem(this.current_route,  JSON.stringify({domainFilters: val}));
                this.$root.$emit('update:domains', val);
            }
        }
    };
</script>
